/*global parent*/
/*eslint no-restricted-globals: [0]*/
import React, { Component } from 'react';
import './App.css';
import 'reveal.js/css/reveal.css'
import 'reveal.js/css/theme/black.css'

import ExtWindow from './ExtWindow'
import ToDo from './ToDo'
import Video from './Video'

class App extends Component {
	constructor(props) {
		super(props)

		this.state = {
			ready: false,
			extwindow: (<ExtWindow id="ext-window"></ExtWindow>)
		}
	}

	componentDidMount() {
		const activate = _ => {
			this.setState({ready: true}, _ => {
				const Reveal = require('reveal.js/js/reveal.js')
				Reveal.initialize({
					width: "100%",
					height: "100%",
					margin: 0.2,
					padding: 0,
					center: false,
					controls: false,
					slideNumber: true,
					history: true,
					transition: 'slide',
					transitionSpeed: 'fast',
					autoPlayMedia: true
				})
				Notification.requestPermission()
				Reveal.addEventListener('slidechanged', _ => {
					switch(_.indexh) {
						case 15-1:
							window.onblur = _ => {
								setTimeout(_ => {
									const notification = new Notification("Wir sollten jetzt WIRKLICH besser präsentieren!", {
										body: "ಠ_ಠ"
									})
									notification.addEventListener('click', _ => {
										notification.close()
										parent.focus()
										window.focus()
										window.onblur = _ => {}
									})
								}, 5000)
							}
							break
						case 24-1:
							setTimeout(_ => new Notification("You just received an Update from your PWA"), 2000)
							break
						case 37-1:
							this.setState({
								extwindow: (
									<ExtWindow nopadding>
										<iframe title="current application" src="https://crc806db.uni-koeln.de"></iframe>
									</ExtWindow>
								)
							})
							break
						case 45-1:
							this.setState({
								extwindow: (
									<ExtWindow nopadding>
										<iframe title="new pwa prototype" src="https://crc806db.uni-koeln.de/beta"></iframe>
									</ExtWindow>
								)
							})
							break
						default:
							break
					}
				})
			})
		}
		document.body.addEventListener('keyup', _ => {
			if(!this.state.ready && _.keyCode === 39) { // arrow-right
				activate()
			}
		})
		document.body.addEventListener('touchend', _ => activate())
	}
	render() {
		return (
			<div className="reveal">
				{this.state.extwindow}
				{this.state.ready && (
					<div className="slides">
						<section>
							<h3 className="slide-from-right">Progressive Web Apps</h3>
							<h4 className="slide-from-left" style={{color: '#cacaca', textTransform: 'none'}}>Costs, Benefits and Tradeoffs</h4>
						</section>

						<section>
							<h3>Agenda</h3>
							<ul>
								<li>Einleitung</li>
								<li>State of Technology</li>
								<li>Implementierung einer PWA</li>
								<li>Fazit</li>
							</ul>
						</section>



						<section>
							<h3>Introduction</h3>
						</section>
						<section>
							<h5>Introduction</h5>
							<h3>Motivation</h3>
							<p>Menschen verrichten Arbeiten oft <em>computergestützt</em>.<br />
							Unterschiede bei Architektur, Betriebssystem, Performance und Netzanbindung.</p>
						</section>
						<section>
							<h5>Introduction - Motivation</h5>
							<p>Adressieren verschiedener Plattformen ist oft mit hohen Aufwänden verbunden</p>
						</section>
						<section>
							<h5>Introduction - Motivation</h5>
							<p>Webapps sind auf jeder Plattform mit Browser verfügbar, weisen jedoch Einschränkungen auf (OS-Integration, Netzanbindung, Performance).</p>
						</section>
						<section>
							<h5>Introduction - Motivation</h5>
							<p>Progressive Web Apps (PWAs) stellen Methoden vor um diese Einschränkungen zu mindern, bzw. entfernen.</p>
						</section>
						<section>
							<h5>Introduction - Motivation</h5>
							<p>„Progressive Web Apps are <em>progressively</em> enhanced web applications that may include specific characteristics“<br /> - Alex Russel [Rus15]</p>
						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>Responsive</h3>
							<p>Stellt sicher das UI-Elemente trotz verschiedener Bildschirmgrößen und -ausrichtungen sichtbar bleiben.</p>
							<Video src={process.env.PUBLIC_URL + "/responsive.mp4"} />
						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>Connectivity independent</h3>
							<p>Kritische Ressourcen werden vom <em>Service Worker</em> vorgecached und zur Verfügung gestellt falls keine Netzanbindung besteht</p>
							<Video src={process.env.PUBLIC_URL + "/sw-precache.mp4"} />
						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>App-like-interactions</h3>
							<p>Das <em>App Shell Model</em> ermöglicht App-ähnliche Interaktion.</p>
							<Video src={process.env.PUBLIC_URL + "/appshell.mp4"} />
						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>Fresh</h3>
							<p>Inhalte können in in aktuellem Zustand nachgeladen werden, während die App Shell durch den <em>Service Worker</em> aktualisiert werden kann.</p>
							<img src={process.env.PUBLIC_URL + "/appshell-1.jpg"} alt="app shell" style={{maxWidth: "400px"}} />

						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>Safe</h3>
							<p>Nutzung von HTTPS um Authentizität, Vertraulichkeit und Integrität sicherzustellen.</p>
							<img src={process.env.PUBLIC_URL + "/https.png"} alt="HTTPS" style={{maxWidth: "400px"}} />
						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>Discoverable</h3>
							<p>Nutzung des <em>Web App Manifests</em> zur Definition von Metadaten</p>
							<img src={process.env.PUBLIC_URL + "/manifest.png"} alt="HTTPS" style={{maxWidth: "500px"}} /><br />
							<small>[Osm16]</small>
						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>Re-engageable</h3>
							<p>Ermöglicht das Wiederaufnehmen der App-Nutzung via Notifications,<br /> auch wenn die App zur Zeit nicht geöffnet ist.</p>
						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>Installable</h3>
							<p>Ermöglicht das Integrieren einer PWA in das Startmenü des Betriebssystems neben nativen Apps.</p>
							<Video src={process.env.PUBLIC_URL + "/installation.mp4"} />
						</section>
						<section>
							<h5>Introduction - PWA Characteristics</h5>
							<h3>Linkable</h3>
							<p>URLs erleichtern das Teilen einer App mit anderen.<br />
							PWAs funktionieren bereits bei Aufruf der URL, ohne weiteres Setup (<em>frictionless</em>).</p>
						</section>
						<section>
							<h5>Introduction</h5>
							<h3>Forschungsfragen</h3>
							<p>„Wofür eignen sich Web Applikationen und wofür nicht?“<br />
							<br />
							„Welche <em>good practices</em> können für die Entwicklung von PWAs identifiziert werden?“</p>
						</section>



						<section>
							<h3>State of Technology</h3>
						</section>
						<section>
							<h5>State of Technology</h5>
							<h3>Server Side Rendering</h3>
							<p>Das angeforderte HTML-Dokument für eine Route wird zur Laufzeit generiert</p>
							<img src={process.env.PUBLIC_URL + "/ssr.png"} alt="Server Side Rendering" style={{maxWidth: "600px"}} /><br />
						</section>
						<section>
							<h5>State of Technology</h5>
							<h3>Client Side Rendering</h3>
							<p>Das HTML-Dokument wird sofort geladen, muss zur Darstellung jedoch JavaScripts laden/compilen/ausführen</p>
							<img src={process.env.PUBLIC_URL + "/csr.png"} alt="Client Side Rendering" style={{maxWidth: "600px"}} /><br />
						</section>
						<section>
							<h5>State of Technology</h5>
							<h3>ServiceWorkers</h3>
							<p>Erlauben die Existenz einer Web Applikation außerhalb des geöffneten Browser-Tabs.</p>
							<img src={process.env.PUBLIC_URL + "/sw-register.png"} alt="Service Worker Registration" style={{maxWidth: "600px"}} /><br />
						</section>
						<section>
							<h5>State of Technology - ServiceWorkers</h5>
							<p>ServiceWorker können Fetch-Events <em>intercepten</em> und mit Ressourcen aus dem Cache antworten.</p>
							<img src={process.env.PUBLIC_URL + "/sw-intercept.png"} alt="Intercepting a Fetch-Event" style={{maxWidth: "800px"}} /><br />
						</section>
						<section>
							<h5>State of Technology - ServiceWorkers</h5>
							<p>ServiceWorker können <em>pushes</em> empfangen und Notifications anzeigen.</p>
						</section>
						<section>
							<h5>State of Technology - ServiceWorkers</h5>
							<h3>Life Cycle (Installation)</h3>
							<Video src={process.env.PUBLIC_URL + "/sw-lifecycle1.mp4"} /> <small>[Arc18]</small>
						</section>
						<section>
							<h5>State of Technology - ServiceWorkers</h5>
							<h3>Life Cycle (Update)</h3>
							<Video src={process.env.PUBLIC_URL + "/sw-lifecycle2.mp4"} /> <small>[Arc18]</small>
						</section>

						<section>
							<h5>State of Technology</h5>
							<h3>App Shell Model</h3>
							<img src={process.env.PUBLIC_URL + "/appshell.png"} alt="Example App Shell" style={{maxWidth: "600px"}} /> <small>[Osm18]</small>
						</section>
						<section>
							<h5>State of Technology</h5>
							<h3>App Shell Model (Skeletons)</h3>
							<img src={process.env.PUBLIC_URL + "/skeleton1.png"} alt="Facebook Skeleton" style={{maxWidth: "200px", display: 'inline-block'}} /> &nbsp; 
							<img src={process.env.PUBLIC_URL + "/skeleton2.png"} alt="Slack Skeleton" style={{maxWidth: "500px", display: 'inline-block', verticalAlign: 'top'}} />
						</section>

						<section>
							<h5>State of Technology</h5>
							<h3>PRPL-Pattern</h3>
							<ul>
								<li><strong>Push</strong> kritische Ressourcen für die Start-Route</li>
								<li><strong>Render</strong> die Start-Route</li>
								<li><strong>Pre-cache</strong> weitere Routen</li>
								<li><strong>Lazy-load</strong> übrige Routen <em>on demand</em></li>
							</ul>
						</section>

						<section>
							<h5>State of Technology</h5>
							<h3>WebWorkers</h3>
							<p>Ermöglichen wahre Nebenläufigkeit statt "nur" Asynchronität.</p>
							<img src={process.env.PUBLIC_URL + "/webworker.png"} alt="Web Worker Registration" style={{maxWidth: "600px"}} /><br />
						</section>

						<section>
							<h5>State of Technology</h5>
							<h3>OS Integration</h3>
							<img src={process.env.PUBLIC_URL + "/manifest2.png"} alt="Web App Manifest" style={{maxWidth: "340px"}} /><br />
						</section>

						<section>
							<h5>State of Technology</h5>
							<h3>Tooling</h3>
							<ul>
								<li>Package Managers</li>
								<li>Module Bundlers</li>
								<li>Transpilers</li>
							</ul>
						</section>
						<section>
							<h5>State of Technology - Tooling</h5>
							<h3>Package Managers</h3>
							<ul>
								<li>Managing von Abhängigkeiten</li>
								<li>Dient oft auch als <em>Task Runner</em></li>
								<li>Greift im Fall von JavaScript auf die NPM Registry zurück</li>
								<li>Bspw.: <em>npm, Yarn</em></li>
							</ul>
						</section>
						<section>
							<h5>State of Technology - Tooling</h5>
							<h3>Module Bundlers</h3>
							<ul>
								<li>Ermöglicht <em>Code Splitting</em></li>
								<li><em>Tree Shaking</em> vermeidet die Auslieferung von no-op code</li>
								<li>Bspw.: <em>Webpack, Browserify</em></li>
							</ul>
						</section>
						<section>
							<h5>State of Technology - Tooling</h5>
							<h3>Transpilers</h3>
							<ul>
								<li>Konvertiert Code von einer Sprache zu einer anderen</li>
								<li>JavaScript als <em>transpile-target</em></li>
								<li>"Saubere" Codebase, keine Polyfills/Vendorprefixes</li>
								<li>Bspw.: <em>Babel</em></li>
							</ul>
						</section>



						<section>
							<h3>Building a PWA</h3>
						</section>
						<section>
							<h5>Building a PWA</h5>
							<h3>Case Study</h3>
							<p>Collaborative Research Centre 806 Database<br />
							eine Plattform für Wissenschaftler um Forschungsergebnisse für andere Verfügbar zu machen.</p>
							<ul>
								<li>Finanziert vom DFG (Deutsche Forschungsgemeinschaft)</li>
								<li>Projekt befindet sich in der letzten Phase (Höchstförderungsdauer)</li>
								<li>Datenbank soll auch in Zukunft bestehen bleiben</li>
								<li>Aktuelles System stark verteilt</li>
								<li>Serverseitige Abhängigkeiten abbauen um Administrationsaufwand gering zu halten</li>
								<li>Lösung: Entwicklung einer PWA?</li>
							</ul>
						</section>
						<section>
							<h5>Building a PWA</h5>
							<h3>Verwendete Technologien</h3>
							<ul>
								<li>Package Manager: <em>npm</em></li>
								<li>Module Bundler: <em>Webpack</em></li>
								<li>Transpiler: <em>Babel</em></li>
								<li>Frontend Framework: <em style={{color: 'dodgerblue'}}>React</em></li>
								<li>Prerendering: <em style={{color: 'dodgerblue'}}>React-Static</em></li>
								<li>Precaching: <em style={{color: 'dodgerblue'}}>Workbox</em></li>
							</ul>
						</section>
						<section>
							<h5>Building a PWA - Verwendete Technologien</h5>
							<h3>Frontend Framework: React</h3>
							<ul>
								<li>Komponenten-basiert</li>
								<li>One-Way Databinding</li>
								<li>Virtual DOM</li>
								<li>Batch-Änderungen</li>
								<li>Großes Ecosystem</li>
								<li>Alternativen: <em>Preact, Vue, Angular</em></li>
							</ul>
						</section>
						<section>
							<h5>Building a PWA - Verwendete Technologien</h5>
							<h3>Frontend Framework: React + JSX</h3>
							<p>Ermöglicht HTML in JS</p>
							<img src={process.env.PUBLIC_URL + "/jsx.png"} alt="Example JSX snippet" style={{maxWidth: "500px"}} /><br />
						</section>
						<section>
							<h5>Building a PWA - Verwendete Technologien</h5>
							<h3>Prerendering: React-Static</h3>
							<ul>
								<li>Automatisches <em>code-/data-splitting</em></li>
								<li>Verwendet und konfiguriert Webpack+Babel</li>
								<li>Integriertes Routing via React-Router</li>
								<li>Erzeugt statische HTML-Dokumente(!)</li>
							</ul><br />
							<img src={process.env.PUBLIC_URL + "/reactstatic.png"} alt="react static code splitting" style={{maxWidth: "350px"}} />
							<small>[Lin17]</small>
						</section>
						<section>
							<h5>Building a PWA - Verwendete Technologien</h5>
							<h3>Prerendering: React-Static</h3>
							<p>Prerendering von statischen HTML-Dokumenten.<br />
							Interaktive Komponenten werden von React <em>hydriert</em>.</p>
							<img src={process.env.PUBLIC_URL + "/reactstatic1.png"} alt="react static prerendering/hydrating" style={{maxWidth: "500px"}} />
							<small>[Lin17]</small>
						</section>
						<section>
							<h5>Building a PWA - Verwendete Technologien</h5>
							<h3>Precaching: Workbox</h3>
							<ul>
								<li>Generiert einen ServiceWorker (generateSW)...</li>
								<li>...oder <em>injiziert</em> in einen bestehenden SW (injectManifest)</li>
								<li>Ermöglicht verschiedene Caching Strategien</li>
							</ul><br />
							<img src={process.env.PUBLIC_URL + "/workboxconfig.png"} alt="workbox example configuration" style={{maxWidth: "500px"}} />
						</section>
						<section>
							<h5>Building a PWA</h5>
							<h3>Befüllen der PWA mit Daten</h3>
							<img src={process.env.PUBLIC_URL + "/architecture.png"} alt="architecture overview" style={{maxWidth: "500px"}} />
						</section>
						<section>
							<h5>Building a PWA</h5>
							<h3>Rebuild PWA</h3>
						</section>
						{/*<section>
							<h5>Building a PWA - Rebuild PWA</h5>
							<h3>Performance</h3>
							<table>
								<thead>
									<tr>
										<th>System</th>
										<th>Route</th>
										<th>load (initial)</th>
										<th>load (consecutive)</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Legacy</td>
										<td>/start</td>
										<td>3.69s</td>
										<td>2.63s</td>
									</tr>
									<tr>
										<td>PWA</td>
										<td>/start</td>
										<td>1.18s</td>
										<td>0.9s</td>
									</tr>
									<tr>
										<td>Legacy</td>
										<td>/publications</td>
										<td>3.66s</td>
										<td>3.24s</td>
									</tr>
									<tr>
										<td>PWA</td>
										<td>/publications</td>
										<td>2.08s</td>
										<td>1.05s</td>
									</tr>
									<tr>
										<td>Legacy</td>
										<td>/publication/show/X</td>
										<td>1.73s</td>
										<td>1.64s</td>
									</tr>
									<tr>
										<td>PWA</td>
										<td>/publication/show/X</td>
										<td>1.15s</td>
										<td>1.62s</td>
									</tr>
								</tbody>
							</table>
						</section>*/}


						<section>
							<h3>Fazit</h3>
							<ul>
								<li>„Wofür eignen sich Web Applikationen (insbesondere PWAs) und wofür nicht?“</li>
								<li>„Welche <em>good practices</em> können für die Entwicklung von PWAs identifiziert werden?“</li>
							</ul>
						</section>
						<section>
							<h5>Fazit</h5>
							<h3>Brauchbarkeit von PWAs</h3>
							<ul>
								<li style={{color: 'dodgerblue'}}>Costs</li>
								<li>Benefits</li>
							</ul>
						</section>
						<section>
							<h5>Brauchbarkeit von PWAs - Costs</h5>
							<h3>Browser Limitationen</h3>
							<ul>
								<li>Kein "richtiger" Zugriff aufs Filesystem</li>
								<li>Kein Zugriff auf Kontakte, Kalendar, Lesezeichen</li>
								<li>Kein Zugriff auf Telefonie-Funktionen</li>
								<li>Nur bestimmte Hardware-Sensoren können ausgelesen werden</li>
								<li>Kein System-Zugriff (Logs, laufende Prozesse, Systemeinstellungen)</li>
								<li>Kann nicht zur Standard-App für bestimmte Dateien/Protokolle werden</li>
							</ul>
						</section>
						<section>
							<h5>Brauchbarkeit von PWAs - Costs</h5>
							<h3>JavaScript <em>Fatigue</em></h3>
							<ul>
								<li>JavaScript Ecosystem verändert sich ständig</li>
								<li>ECMAScript-Standard entwickelt sich ständig weiter</li>
								<li>Aufsetzen eines Projektes kann viel Zeit beanspruchen</li>
								<li>Es wird schwieriger sich auf bestimmte Frameworks festzulegen</li>
							</ul>
						</section>
						<section>
							<h5>Brauchbarkeit von PWAs - Costs</h5>
							<h3>ServiceWorker Life Cycle</h3>
							<ul>
								<li>Es ist nicht leicht den ServiceWorker korrekt einzusetzen</li>
								<li>Kann negative Folgen haben</li>
							</ul>
						</section>
						<section>
							<h5>Fazit</h5>
							<h3>Brauchbarkeit von PWAs</h3>
							<ul>
								<li>Costs</li>
								<li style={{color: 'dodgerblue'}}>Benefits</li>
							</ul>
						</section>
						<section>
							<h5>Brauchbarkeit von PWAs - Benefits</h5>
							<h3>Teilbar und Linkbar</h3>
							<p>Web Apps können generell sehr leicht mit anderen via Link geteilt werden.</p>
						</section>
						<section>
							<h5>Brauchbarkeit von PWAs - Benefits</h5>
							<h3>Endgerät-Unabhängig</h3>
							<p>Funktionsfähig auf jeder Plattform mit einem modernen Browser,<br />
							unabhängig von Architektur/Betriebssystem.</p>
						</section>
						<section>
							<h5>Brauchbarkeit von PWAs - Benefits</h5>
							<h3>Sofortiges Deployment</h3>
							<p>Web Apps können sofort aktualisiert werden ohne Nutzerinput aktualisiert werden.<br />
							Etwaige Prüfungen durch App-Store-Betreiber fallen nicht an.</p>
						</section>
						<section>
							<h5>Brauchbarkeit von PWAs - Benefits</h5>
							<h3>Zugänglichkeit</h3>
							<p>Web Apps benötigen kein technisches Einrichten.<br />
							Vorteilhaft bei weniger versierten Nutzern oder eingeschränkten Benutzeraccounts.</p>
						</section>
						<section>
							<h5>Brauchbarkeit von PWAs - Benefits</h5>
							<h3>Niedriger Speicherbedarf</h3>
							<p>Rendering durch Browsersoftware,<br />dadurch deutlich geringerer Speicherbedarf, verglichen mit nativen Apps.</p>
						</section>

						<section>
							<h5>Fazit</h5>
							<h3>Good Practices</h3>
							<ul>
								<li>Organisatorische Belange (3)</li>
								<li>Funktionale Belange (3)</li>
								<li>Usability Belange (15)</li>
							</ul>
						</section>
						<section>
							<h5>Good Practices - Organisatorische Belange</h5>
							<h3>Schule Entwickler mit dem Umgang des aktuellen ECMAScript-Standards</h3>
							<p><em>Arrow-Notation, async/await, Promises, const/let vs. var, class-syntax</em></p>
						</section>
						<section>
							<h5>Good Practices - Organisatorische Belange</h5>
							<h3>Auf einen ServiceWorker-Dateinamen festlegen und dabei bleiben</h3>
							<p>Um sicherzustellen das dieser jederzeit ersetzt werden kann.<br />
							Auf keinen Fall <em>sw-v1.js, sw-v2.js, etc</em>!</p>
						</section>
						<section>
							<h5>Good Practices - Organisatorische Belange</h5>
							<h3>Caching des Webservers für den ServiceWorker deaktivieren <sup style={{color: '#ff3333', fontSize: '0.5em'}}>Neu</sup></h3>
							<p>Cache-Control Header sollten gesetzt werden um das korrekte Funktionieren des Service Worker Life Cycle zu ermöglichen</p>
							<img src={process.env.PUBLIC_URL + "/sw-cachecontrol.png"} alt="Caching Headers" style={{maxWidth: "340px"}} /><br />
						</section>
						<section>
							<h5>Good Practices - Organisatorische Belange</h5>
							<h3>Entkoppeln von front-end und back-end</h3>
							<p>Gewährleistet Austauschbarkeit und ermöglicht größere Kontrolle über die jeweiligen Projekte.</p>
						</section>

						<section>
							<h5>Good Practices - Funktionale Belange</h5>
							<h3>Verwende HTTPS-Verschlüsselung</h3>
							<p>Gewährleistet Authentizität, Vertraulichkeit und Integrität.<br />
							Grundvoraussetzung für <em>ServiceWorker</em></p>
						</section>
						<section>
							<h5>Good Practices - Funktionale Belange</h5>
							<h3>Verwende einen Transpiler um Browser-Kompatibilität zu gewährleisten</h3>
							<p>Ermöglicht eine moderne code-base ohne Polyfills/Vendorprefixes.</p>
							<img src={process.env.PUBLIC_URL + "/vendorprefixes.png"} alt="Example vendorprefixes" style={{maxWidth: "500px"}} /><br />
						</section>
						<section>
							<h5>Good Practices - Funktionale Belange</h5>
							<h3>Verwende eine <em>cache-first network-strategy</em> wenn möglich</h3>
							<p>Stellt Inhalte sofort, ohne weitere Netzwerkverzögerungen bereit.</p>
						</section>

						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Verwende ein <em>responsive grid layout</em> um verschiedenen Bildschirmgrößen gerecht zu werden</h3>
							<p>Erhöht Zugänglichkeit für mehr Nutzergruppen.</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3><em>Pre-cache</em> kritische Ressourcen um Ladezeiten zu verringern</h3>
							<p>Ideal bei der Nutzung des App-Shell-Models.<br />
							Teil des PRPL-Pattern.</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Verwende einen <em>module bundler</em> um die übermittelten Daten pro Route aufs Minimum zu reduzieren</h3>
							<p>Vermeidung von <em>dead code</em>.<br />
							Ermöglicht <em>code-splitting</em>.</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Verwende semantisches HTML markup und JSON-LD</h3>
							<p>Bessere Indizierung von Suchmaschinen.</p>
							<img src={process.env.PUBLIC_URL + "/semanticmarkup.png"} alt="Google result with semantic data" style={{maxWidth: "800px"}} />
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Verwende ARIA-Rollen for uneindeutige HTML-Elemente</h3>
							<p>Erleichtert u.a. die Verwendung von Screen Readern</p>
							<img src={process.env.PUBLIC_URL + "/aria.png"} alt="example of ARIA roles" style={{maxWidth: "800px"}} />
							<small>[Kea+18]</small>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3><em>Pre-rendern</em> von statische Routen</h3>
							<p>Für schnellste Darstellung.</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Verwende das <em>app shell model</em> für dynamische Inhalte</h3>
							<p>Zusammen mit <em>Skeleton Pages</em> um die empfundene Performance zu erhöhen</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Lagere langsame Prozesse auf <em>Web Worker</em> aus</h3>
							<p>Um den UI-Thread zu entlasten und "Ruckler" zu vermeiden.</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3><em>Preloade</em> die Ressourcen die mit hoher Wahrscheinlichkeit für kommende Routen benötigt werden</h3>
							<p>Verringert die Ladezeit für Folgerouten.</p>
							<img src={process.env.PUBLIC_URL + "/precache.png"} alt="list of precached files" style={{maxWidth: "500px"}} /><br />
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Deaktiviere das Markieren von Text für interaktive Elemente wie z.B. Buttons</h3>
							<p>Um das Öffnen von Text-Selektierungs Werkzeugen zu vermeiden.</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Verwende feste Größen bei Platzhaltern für Bilder</h3>
							<p>Damit Inhalte nicht plötzlich zur Seite "springen"</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Verwende <em>page-transitions</em> um die empfundene Performance zu erhöhen</h3>
							<p>
								<img src={process.env.PUBLIC_URL + "/pagetransition.gif"} alt="page transition with shared elements" style={{maxWidth: "200px", verticalAlign: 'top'}} />
								<small>[Fer17]</small>
							</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Scroll positionen sollten erhalten bleiben wenn von einer Detailansicht zurück zu einer Listenansicht navigiert wird</h3>
							<p>Insbesondere bei <em>endless scrollern</em> wichtig.</p>
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Biete den Nutzern einen <em>Share-Button</em> falls es möglich ist die PWA im Vollbild zu öffnen</h3>
							<p>Da die Adressleiste des Browsers in diesem Fall nicht mehr sichtbar ist.</p>
							<img src={process.env.PUBLIC_URL + "/launchnobrowser.png"} alt="Launch without visible browser" style={{maxWidth: "400px"}} />
						</section>
						<section>
							<h5>Good Practices - Usability Belange</h5>
							<h3>Vermeide "hamburger menüs" für essentielle Routen</h3>
							<p>So bleiben Navigationsoptionen stets sichtbar.</p>

							<img src={process.env.PUBLIC_URL + "/nohamburger1.gif"} alt="Hamburger menu" style={{maxWidth: "140px", display: 'inline-block'}} /> &nbsp; 
							<img src={process.env.PUBLIC_URL + "/nohamburger2.gif"} alt="Bottom navigation" style={{maxWidth: "140px", display: 'inline-block', verticalAlign: 'top'}} />
							<small>[Abr14]</small>
						</section>


						<section>
							<h3>Sources</h3>
							<div style={{fontSize: '0.4em', textAlign: 'left'}}>
								[Abr14] Luis Abreu (2014): <em>Why and How to Avoid Hamburger Menus</em>, <a href="https://lmjabreu.com/post/why-and-how-to-avoid-hamburger-menus/">https://lmjabreu.com/post/why-and-how-to-avoid-hamburger-menus/</a> (last accessed: 2018-05-22)
							</div>
							<div style={{fontSize: '0.4em', textAlign: 'left'}}>
								[Arc18] Jake Archibald (2018): <em>The Service Worker Lifecycle</em>, <a href="https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle">https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle</a> (last accessed: 2018-05-18)
							</div>
							<div style={{fontSize: '0.4em', textAlign: 'left'}}>
								[Fer17] Florian Ferbach (2017): <em>How To Implement Material Design Motion with React.js</em>, <a href="https://marmelab.com/blog/2017/12/04/material-design-animations-react-router.html">https://marmelab.com/blog/2017/12/04/material-design-animations-react-router.html</a> (last accessed: 2018-05-22)
							</div>
							<div style={{fontSize: '0.4em', textAlign: 'left'}}>
								[Kea+18] Meggin Kearney, Dave Gosh, Alice Boxhall (2018): <em>Introduction to ARIA</em>, <a href="https://developers.google.com/web/fundamentals/accessibility/semantics-aria/">https://developers.google.com/web/fundamentals/accessibility/semantics-aria/</a> (last accessed: 2018-05-22)
							</div>
							<div style={{fontSize: '0.4em', textAlign: 'left'}}>
								[Lin17] Tanner Linsley (2017): <em>⚛️ 🚀 Introducing React-Static — A progressive static-site framework for React!</em>, <a href="https://medium.com/@tannerlinsley/%EF%B8%8F-introducing-react-static-a-progressive-static-site-framework-for-react-3470d2a51ebc">https://medium.com/@tannerlinsley/%EF%B8%8F-introducing-react-static-a-progressive-static-site-framework-for-react-3470d2a51ebc</a> (last accessed: 2018-05-23)
							</div>
							<div style={{fontSize: '0.4em', textAlign: 'left'}}>
								[Osm16] Addy Osmani (2016): <em>Progressive Web Apps with React.js: Part I — Introduction</em>, <a href="https://medium.com/@addyosmani/progressive-web-apps-with-react-js-part-i-introduction-50679aef2b12">https://medium.com/@addyosmani/progressive-web-apps-with-react-js-part-i-introduction-50679aef2b12</a> (last accessed: 2018-05-15)
							</div>
							<div style={{fontSize: '0.4em', textAlign: 'left'}}>
								[Osm18] Addy Osmani (2018): <em>The App Shell Model</em>, <a href="https://developers.google.com/web/fundamentals/architecture/app-shell">https://developers.google.com/web/fundamentals/architecture/app-shell</a> (last accessed: 2018-05-15)
							</div>
							<div style={{fontSize: '0.4em', textAlign: 'left'}}>
								[Rus15] Alex Russel (2015): <em>Progressive Web Apps: Escaping Tabs Without Losing Our Soul</em>, <a href="https://infrequently.org/2015/06/progressive-apps-escaping-tabs-without-losing-our-soul/">https://infrequently.org/2015/06/progressive-apps-escaping-tabs-without-losing-our-soul/</a> (last accessed: 2018-01-09)
							</div>

						</section>
					</div>
				)}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js